import { render, staticRenderFns } from "./MolliePayment.vue?vue&type=template&id=e2da0530&"
import script from "./MolliePayment.vue?vue&type=script&lang=ts&"
export * from "./MolliePayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports